<nz-layout>
  <nz-content>
    <div class="authContainer" [ngClass]="{
        'cui__layout__squaredBorders': isSquaredBorders,
        'cui__layout__cardsShadow': isCardShadow,
        'cui__layout__borderless': isBorderless,
        'white': authPagesColor === 'white',
        'gray': authPagesColor === 'gray'

      }" [ngStyle]="{backgroundImage: authPagesColor === 'image' ? 'url(assets/images/content/photos/7.jpg)' : ''}">
      <div class="topbar" [ngClass]="{
        'topbarGray': isGrayTopbar
      }">
        <div class="logoContainer">
          <div class="logo">
            <img src="assets/images/4K-logo.svg" class="mr-2" alt="4K Analytics" />
            <div class="name">{{ logo }}</div>
            <div *ngIf="logo === '4K Analytics'" class="descr"></div>
          </div>
        </div>
        <div class="d-none d-sm-block">
          <span class="mr-2"></span>
          <a routerLink="/auth/register" class="font-size-16 kit__utils__link">

          </a>
        </div>
      </div>
      <div class="containerInner">
          <router-outlet #outlet="outlet"></router-outlet>
      </div>
      <div class="mt-auto pb-5 pt-5">
				<div class="text-center">
					Version: {{versions.version}}
				</div>
      </div>
    </div>
  </nz-content>
</nz-layout>
